import useTypedContext from "hooks/useTypedContext";

import ScanSettingsFormWrapper from "../components/FormWrapper";
import ScanSettingsPageLayout from "../components/PageLayout";
import { ScanSettingsContextData } from "../Context";
import ScanSettingsCloudProviderEdit from "./Edit";
import ScanSettingsCloudProviderView from "./View";

const ScanSettingsCloudProvider = () => {
  const { canUpdateScan } = useTypedContext(ScanSettingsContextData);

  return (
    <ScanSettingsPageLayout
      title="Cloud provider"
      description="Configure the provider version, integration, and regions used to run this scan."
    >
      <ScanSettingsFormWrapper>
        {canUpdateScan.result ? (
          <ScanSettingsCloudProviderEdit />
        ) : (
          <ScanSettingsCloudProviderView />
        )}
      </ScanSettingsFormWrapper>
    </ScanSettingsPageLayout>
  );
};

export default ScanSettingsCloudProvider;
